module.exports = "query Notices($page: Int = 1, $limit: Int = 10, $status: String) {\n  notices(page: $page, limit: $limit, status: $status) {\n    data {\n      id\n      name\n      image\n      image_mobile\n      start_date\n      end_date\n      resource_id\n      resource_type\n      link\n      type\n      allowed {\n        name\n        id\n      }\n      clicks\n      opens\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Popup.graphql
// module id = MQ9D
// module chunks = 1624